import React, { useState, useEffect } from 'react';
import { Grid, TablePagination, useMediaQuery, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { submitDemo } from '../../_services/creater/creatorDemo.service';
import {
  fetchLoginUser,
  fetchUserDetail,
  setLoader,
  setSnackBar,
  setSnackBarMessage,
  setSnackBarVariant
} from '../../redux';
import { formSnackbar } from '../../_services/_constants/snackbar.constant';
import { Add } from '@mui/icons-material';
import DemoCard from './DemoCard';
import NoResults from '../../components/reusableComponents/NoResults';
import { default_limit, record_limits } from '../../_services/_constants/recordLimitset.constant';

function DemoList(props) {
  const dispatch = useDispatch();
  const userData = useSelector(state => state.userData.userData);
  let smScreen = useMediaQuery('(max-width:768px)');
  const [demoList, setDemoList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(default_limit);
  const [totalCount, setTotalCount] = useState(0);

  const isNextButtonDisabled = demoList.length < rowsPerPage || (page + 1) >= Math.ceil(totalCount / rowsPerPage);
  const isPreviousButtonDisabled = page === 0;

  useEffect(() => {
    if (userData.id) {
      dispatch(fetchLoginUser(userData.id));
    }
  }, [userData.id, dispatch]);

  useEffect(() => {
    if (userData.id) {
      setPage(0);
      demoData(userData.id, 0, rowsPerPage);
    }
  }, [userData.id, rowsPerPage]);

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const newPage = Math.min(
      Math.floor((page * rowsPerPage) / newRowsPerPage),
      Math.ceil(1000 / newRowsPerPage) - 1
    );
    setRowsPerPage(newRowsPerPage);
    setPage(newPage);
    demoData(userData.id, newPage, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const newOffset = newPage;
    demoData(userData.id, newPage, rowsPerPage, newOffset);
  };

  const demoData = (userId, page, rowsPerPage, offset) => {
    const limit = rowsPerPage;
    dispatch(setLoader(true));
    submitDemo({ 'userId': userId }, 'GET',  null, limit, offset)
      .then(function (response) {
        dispatch(setLoader(false));
        setDemoList(response.data.results);
        setTotalCount(response.data.total_count);
        dispatch(fetchUserDetail());
      })
      .catch(function (error) {
        dispatch(setLoader(false));
        console.log(error);
        console.log(error.response);
        return error.response;
      });
  };

  const resetDemoDataList = () => {
    setDemoList(null);
    demoData(userData.id, page);
  };

  const handleDeleteItem = (data) => {
    if (data !== undefined) {
      dispatch(setSnackBarVariant('info'));
      dispatch(setSnackBarMessage(formSnackbar.submitDemo.DemoDelete));
      setTimeout(() => dispatch(setSnackBar(false)), 2000);
      dispatch(setSnackBar(true));
      let itemId = data;

      submitDemo({ 'itemId': itemId }, 'DELETE').then(function (response) {
        if (response.status === 204 || response.status === 200) {
          dispatch(setSnackBarVariant('success'));
          dispatch(setSnackBarMessage(formSnackbar.submitDemo.DemoDeleteSuccess));
          dispatch(setLoader(false));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
          demoData(userData.id, page);
        } else {
          dispatch(setSnackBarMessage(formSnackbar.serviceRequest.serviceRequestFailure));
          dispatch(setSnackBarVariant('error'));
        }
      });
    }
  };

  const handleEdit = (item) => {
    if (props.onEdit) {
      props.onEdit(item); // pass entire item (includes id, genre, mood, etc.)
    }
  };

  if (userData.id === "") {
    return <h1>Loading...</h1>;
  }

  return (
    <div className={smScreen ? 'p-2' : 'p-4'}>
      <h2>Submit Demo</h2>
      <div className='mt-4'>
        <button className='gn-actionbtn' onClick={props.handleChange}>
          <Add />Add Demo
        </button>
      </div>

      <div className='my-4'>
        {demoList && demoList.length > 0 ? (
          <Box>
            {/* Grid Container for Cards */}
            <Grid
              container
              spacing={2}
              sx={{
                alignItems: 'stretch'
              }}
            >
              {demoList.map((item) => (
                <DemoCard
                  key={item.id}
                  cardData={item}
                  moduleName={'demoList'}
                  dataList={demoList}
                  getDataList={resetDemoDataList}
                  handleDeleteItem={handleDeleteItem}
                  onEdit={() => handleEdit(item)}
                />
              ))}
            </Grid>

            {/* Pagination */}
            {!smScreen ? (
              <TablePagination
                rowsPerPageOptions={record_limits}
                colSpan={3}
                sx={{ width: '100%', marginTop: '20px', padding: '32px 0px 32px 32px' }}
                className="cardPagination"
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                nextIconButtonProps={{ disabled: isNextButtonDisabled }}
              />
            ) : (
              <Box
                className="d-flex justify-content-between mb-5"
                sx={{ width: '100%', marginTop: '20px', gap: 2 }}
              >
                <Box sx={{ width: '50%' }}>
                  <button
                    onClick={() => handleChangePage(null, page - 1)}
                    disabled={isPreviousButtonDisabled}
                    className={`pagination-button ${isPreviousButtonDisabled ? 'disabled' : 'enabled'}`}
                  >
                    Previous
                  </button>
                </Box>
                <Box sx={{ width: '50%' }}>
                  <button
                    onClick={() => handleChangePage(null, page + 1)}
                    disabled={isNextButtonDisabled}
                    className={`pagination-button ${isNextButtonDisabled ? 'disabled' : 'enabled'}`}
                  >
                    Next
                  </button>
                </Box>
              </Box>
            )}
          </Box>
        ) : (
          <NoResults message="No Result Found" />
        )}
      </div>
    </div>
  );
}

export default DemoList;